import { defineStore } from 'pinia'

export const useEditModeStore = defineStore('editMode',{
  state: () => {
    return {
      edit: false,
    }
  },
  getters: {
    isEdit: state => state.edit,
  },
  actions: {
    changeEditMode(data) {
      this.edit = data === 'on'
    },
  },
  strict: false,
})
